export const setAriaLabelledByToElement = (elementClassname, idToAssociate) => {
    let e = document.getElementsByClassName(elementClassname).item(0);
    e && e.setAttribute("aria-labelledby", idToAssociate);
};
